import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { FilterProjectDto } from 'src/app/web/interfaces/project/list/filterProjectDto';
import { FilterProjectInfoDto } from 'src/app/web/interfaces/project/list/filterProjectInfoDto';
import { FilterProjectInfoFrenteDto } from 'src/app/web/interfaces/project/list/filterProjectInfoFrenteDto';
import { FilterProjectInfoItemDto } from 'src/app/web/interfaces/project/list/filterProjectInfoItemDto';
import { FilterProjectStadoDto } from 'src/app/web/interfaces/project/list/filterProjectStadoDto';
import { ViewProject } from 'src/app/web/interfaces/project/list/viewProjectDto';
import { DropdownSettingsStado, FormatDataTableGlobal } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2/dist/sweetalert2.js'; 
import { ApiServiceERP } from '../../../apis/ApiServiceERP';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorService } from 'src/app/shared/services/errors.service';

export class listClient {

  id: number;
  name:string;
  listFrente: {};
  listHeadquarter:{};
  
  
}

@Component({
  selector: 'app-list-client',
  templateUrl: './list-client.component.html',
  styleUrls: ['./list-client.component.scss']
})
export class ListClientComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  dtOptions: DataTables.Settings = {};

  private apiService: ApiServiceERP;

  searchForm: FormGroup;
  paymentsform: FormGroup;
  listViewProjectDto: ViewProject[] = []
  listViewProjectDtoBack: ViewProject[] = []
  filterProjectInfoDto: FilterProjectInfoDto = {} as FilterProjectInfoDto
  filterProjectInfoFrenteDto: FilterProjectInfoFrenteDto[] = []
  filterProjectDto: FilterProjectDto = {} as FilterProjectDto;
  ListClient: listClient[] = []
  selectedItems = [];
  dropdownSettings = {};
  opcionClient = 0
  opcionFrete = 0
  opcionSeleccionado = "todo"
  items!: FormArray;
  permiso: number[] = []

  constructor(private http: HttpClient,
    private spinner: NgxSpinnerService,
    config: NgbDropdownConfig,
    private fb: FormBuilder,
    private errorService:ErrorService) 
    {
      config.placement = 'bottom';
    }

  ngOnInit(): void {

    this.dtOptions = FormatDataTableGlobal();
    this.dropdownSettings = DropdownSettingsStado();
    this.apiService =  new ApiServiceERP(this.http);

 
    this.spinner.show();
    // this.permiso = this.errorService.getPermisses();
    // if (this.permiso.find(element => element == 14)) {
    // }  else {
    //   this.errorService.error2(403)
    //   this.spinner.hide();
    // }

    this.apiService.getService('client-list').subscribe({
      next: (rs:any) => {

        if (rs.code == null) {
          // si la respuesta no tiene error pero no tiene data se manda un mensaje de error y se retorna al home
          if (rs == '' || rs == null) {
            this.spinner.hide();
            Swal.fire({
              title: 'No se encontraron registros',
              text: '',
              icon: 'info',
              confirmButtonText: 'Aceptar',
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed || res.isDismissed) {
               
              }
            });
          }
          this.ListClient = rs;
          localStorage.setItem("info-mtn", JSON.stringify(rs));
          
          
          this.spinner.hide();
          this.rerender();
        } else {
          
          this.spinner.hide();
          Swal.fire({
            title:  rs.error,
            text: '',
            icon: 'error',
            heightAuto: false
            });
        }
      },
      error: (error) => {
        this.errorService.error(error);
      },
    });

  }

  get form() {
    return this.searchForm.controls;
  }

  onItemSelect(item: any) {

  }

  actionSelectClient(){
    this.filterProjectInfoFrenteDto = this.form['client'].value.listFrente;

  }

  nuevoCampo() {
    this.items = this.paymentsform.get("items") as FormArray
    let info = this.fb.group({
      hes: "",
      facture: "",
      facture_date: ""
    });

    this.items.push(info)

  }

  btnSearch() {
    let idFrente = 0;
    let idClient = 0;
    let idType = 0;

    let activeEnd = 0;
    let closedEnd = 0;
    let stopEnd = 0;


    if(this.form['client'].value.id != null){
      idClient = this.form['client'].value.id ;

      if(this.form['frete'].value.id != null){
        idFrente = this.form['frete'].value.id ;
      }
    }

    if(this.form['type'].value.id != null){
      idType = this.form['type'].value.id ;
    }
    if(this.form['stado'].value[0] != null){
      let activos =  this.form['stado'].value.filter( n =>  n.name.t == "ActIvos")
      let pausados =  this.form['stado'].value.filter( n =>  n.name == "Pausados")
      let cerrados =  this.form['stado'].value.filter( n =>  n.name == "Cerrados")

      if(activos[0] != null){
        Swal.fire({title:"Debe selecciona una de estado",text: '',icon: 'error',heightAuto: false});
        return;
      }
      
      if(pausados[0] != null){
        stopEnd = 1
      }
      
      if(cerrados[0] != null){
        closedEnd = 1
      }
    }else{
      Swal.fire({title:"Debe selecciona una de estado",text: '',icon: 'error',heightAuto: false});
      return;
    }

    let item = []
    for(let info of this.form['item'].value){
      item.push(info.id)
    }

    if(item.length == 0){
      Swal.fire({title:"Debe selecciona un Item",text: '',icon: 'error',heightAuto: false});
      return;
    }


    let listFilterTaasStadoDto: FilterProjectStadoDto[] = []

    let filterTaasStadoDto: FilterProjectStadoDto = {
      active: activeEnd,
      closed: closedEnd,
      stop: stopEnd
    };

    listFilterTaasStadoDto.push(filterTaasStadoDto)

    this.filterProjectDto.client_id = idClient
    this.filterProjectDto.frentes_id = idFrente
    this.filterProjectDto.itemSelect = item
    this.filterProjectDto.type_id = idType
    this.filterProjectDto.stado = listFilterTaasStadoDto

    this.searchInfo(this.filterProjectDto)
  }

  searchInfo(info:FilterProjectDto){

    this.spinner.show();

    this.apiService.postService("list-project",info).subscribe({
      next: (rs:any) => {

        if(rs.code == null){
          this.listViewProjectDto = [];
          this.listViewProjectDtoBack = [];
          this.opcionSeleccionado = "todo"
          this.listViewProjectDto = rs
          this.listViewProjectDtoBack = rs;
          this.spinner.hide()
          this.rerender()
        }else{
          this.listViewProjectDto = [];
          this.listViewProjectDtoBack = [];
          this.rerender()
          this.spinner.hide()
          Swal.fire({
            title:  rs.error,
            text: '',
            icon: 'error',
            heightAuto: false
            });
        }
      
      },
      error: (error) => {
        this.errorService.error(error);
      }
    });
  }
  
  actionSelectFiter(opcionSeleccionado:any){
    this.listViewProjectDto = this.listViewProjectDtoBack 

    if(opcionSeleccionado.target.value == "todo"){
      return;
    }

    this.listViewProjectDto = this.listViewProjectDto.filter( n =>  n.payment.colorStatus == opcionSeleccionado.target.value)

    if(this.listViewProjectDto[0] == null){
      this.listViewProjectDto = []
    }
    this.rerender()

  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  stageDeleteClient(id:any){
    Swal.fire({
              title: 'Eliminar',
              text: '¿Desea eliminar el cliente?',
              icon: 'error',
              showCancelButton:true,
              confirmButtonText: 'Aceptar',
              cancelButtonText:"No, cancelar",
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed) {
                this.spinner.show()
                this.apiService.deleteService('client-delete?id=' + id).subscribe({
                  next: (rs: any) => {
                    if (rs) {
                      this.spinner.hide();
                      Swal.fire({title:'Exito!',text: 'Se ha eliminado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                      
                    } else {
                        this.spinner.hide();
                        Swal.fire({
                          title:  rs.error,
                          text: '',
                          icon: 'error',
                          heightAuto: false
                          }); } },
                  error: (error) => {
                    this.errorService.error(error);
                  },});
              }
              else if ( res.dismiss === Swal.DismissReason.cancel){
                Swal.fire({
                  title: 'Cancelado',
                  text: 'Operación cancelada.',
                  icon: 'error',
                  heightAuto: false
                  })

              }
            });


  }

}
